import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getQueuesResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskPracticeNewRoute } from '@atlassian/jira-router-routes-servicedesk-queues-routes/src/servicedeskPracticeNewRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import ServiceDeskQueuesCreateView, {
	LazyServicedeskQueuesCreateView,
} from './ui/create-view/index.tsx';

export const servicedeskPracticeNewRouteEntry = createEntry(servicedeskPracticeNewRoute, () => ({
	group: 'servicedesk',
	component: ServiceDeskQueuesCreateView,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
	},

	resources: [...getQueuesResources(), getConsolidationStateResource()],
	forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesCreateView],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskPracticeNewRouteEntry.tsx',
			whichExportToUse: 'servicedeskPracticeNewRouteEntry',
		},

		enabled: true,
	},
}));
